import './SystemConfigureMenu.style.less'
import { Menu } from 'antd'
import { useNavigate } from 'react-router-dom'

function SystemConfigureMenu() {
  const navigate = useNavigate()

  return (
    <div className="system-setting-container">
      <Menu
        defaultOpenKeys={[
          'user-management',
          'data-management',
          'template-management',
        ]}
        mode="inline"
      >
        <Menu.SubMenu
          key={'user-management'}
          title="User Management"
          className="main-menu"
        >
          <Menu.Item
            onClick={() => navigate('user-management/users')}
            className="sub-menu"
          >
            Users
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu
          key={'data-management'}
          title="Data Management"
          className="main-menu"
        >
          <Menu.SubMenu title="Partner" className="sub-menu">
            <Menu.Item
              onClick={() => navigate('data-management/supplier')}
              className="menu-item"
            >
              Suppliers
            </Menu.Item>
            <Menu.Item
              onClick={() => navigate('data-management/factory')}
              className="menu-item"
            >
              Factories
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu title="Orders" className="sub-menu">
            <Menu.Item
              className="menu-item"
              onClick={() => navigate('data-management/property')}
            >
              Properties
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu title="Defects" className="sub-menu">
            {/* <Menu.Item
              className="menu-item"
              onClick={() => navigate('data-management/defect-category')}
            >
              Defect Categories
            </Menu.Item> */}
            <Menu.Item
              className="menu-item"
              onClick={() => navigate('data-management/defect-list')}
            >
              Defect List
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu title="Inspection" className="sub-menu">
            <Menu.Item
              onClick={() => navigate('data-management/inspection-type')}
              className="menu-item"
            >
              Inspection Type
            </Menu.Item>
            <Menu.Item
              onClick={() => navigate('data-management/inspection-aql')}
              className="menu-item"
            >
              Inspection AQL
            </Menu.Item>
          </Menu.SubMenu>
        </Menu.SubMenu>
        <Menu.SubMenu
          key={'template-management'}
          title="Template Management"
          className="main-menu"
        >
          <Menu.Item
            onClick={() => navigate('template/inspection-template')}
            className="sub-menu"
          >
            Inspection Templates
          </Menu.Item>
          <Menu.Item
            onClick={() => navigate('template/order-template')}
            className="sub-menu"
          >
            Order Templates
          </Menu.Item>
          <Menu.Item
            onClick={() => navigate('template/time-action-template')}
            className="sub-menu"
          >
            Time & Action Templates
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
    </div>
  )
}

export default SystemConfigureMenu
